import React from 'react'
import { useTranslation } from 'react-i18next';
import '../css/conexion.css'
import Afiliado from '../components/form/Afiliado'
import bannerConexion from '../assets/images/alianza/banner-conexion.jpg'
import Footer from '../components/Footer';
import { Outlet, Link } from "react-router-dom";
import reservacion from '../assets/images/cta/reservacion.svg'
import rutas from '../assets/images/cta/rutasyhorarios.svg'
import preguntas from '../assets/images/cta/tarifas.svg'

export default function ContectaTuTrayecto() {
    const { t } = useTranslation('RrutasHorario');
    
  return (
    <>
        <section>
                <div className='header_section'>
                    <div className='container header_section_box'>
                        <div className='header_section_title'>
                            <h3>Ahora llegas más lejos</h3>
                            <p>Con más de 1,800 destinos que conectan con los que más quieres</p>
                        </div>                
                    </div>
                </div>
            </section>
            <section style={{background: '#E8E8E8'}}>
                <Afiliado />
            </section>

        <section className='conectando-transporte'>
            <div className='container'>
                <div className='conectando-transporte-content'>
                    <div>                        
                        <a href="https://bajaferries.estrellablanca.com.mx/ferries" rel='noopener noreferrer' target="_blank">
                            <img src={bannerConexion} alt='baja ferries conexion terrestre' />
                        </a>                                                                                                    
                    </div>
                  
                    <h4>Conecta tu llegada con tu siguiente trayecto</h4>
                    <p>Ahora, al llegar con Baja Ferries, es más fácil continuar tu viaje.</p>                                    

                    <p>Ponemos a tu alcance opciones de traslado terrestre con aliados como Élite y Águila, para que elijas la ruta que mejor se adapte a tu destino y sigas tu camino sin complicaciones.</p>

                    <div className='content_promo_btn'>
                        <a href="https://bajaferries.estrellablanca.com.mx/ferries" rel='noopener noreferrer' target="_blank" className='cta_promo'>Ver opciones de traslado</a>
                        <a href="https://booking.bajaferries.com.mx/es/book/journey-booking/journeySearch/?clear&aff=11313544" rel='noopener noreferrer' target="_blank" className='cta_promo'>Reservar</a>


                    </div>                                   

                </div>
            </div>
        </section>
    <section className="callToAction">
        <div className='container'>
            <div>
                <h3> </h3>
            </div>
            <div className='callToAction_row'>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={preguntas} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title1')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title1')}</p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/tarifas">{t('cta_btn1')}</Link>
                        </div>
                    </div>
                </div>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={rutas} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title2')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title2')}</p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/rutas_horario">{t('cta_btn2')}</Link>     
                        </div>
                    </div>
                </div>

                 <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={reservacion} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title3')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title3')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                        <a href="tel:8003377437" target="_blank" rel="noopener noreferrer">{t('cta_btn3')}</a>                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Outlet />
    <Footer />
    
    </>
  )
}
